import { ResultOptions } from "@design-controls/types";
import i18n from "../i18n/config";

export const ResultValueToLabel: { [key in ResultOptions]: string } = {
  passed: i18n.t("statuses.testResult.passed"),
  failed: i18n.t("statuses.testResult.failed"),
  blocked: i18n.t("statuses.testResult.blocked"),
};
